import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { Subtitulo, Texto1Linea } from 'app-principal-componentes-visuales';
import React, { useState } from 'react';
import { capitalizeString } from '../../../utils/utils';
import './DatosUbicacionAccordion.scss';

const DatosUbicacionAccordion = ({casoBD}) => {
    const [datosUbicacionAccordion, setDatosUbicacionAccordion] = useState(true);

    const formatInformacionAdicional = (domicilio, direcciones) => {
        const domicilioSplit = domicilio.split(',');
        const regex = /\d+/g;
        const nro = domicilioSplit[0]?.match(regex) ?? '0';
        const calle = domicilioSplit[0].replace(/[0-9]/g, '');

        const direccion = direcciones.find((direccion) => {
            if(domicilioSplit.length === 4){
                return (direccion.calle === calle.trim()  && direccion.altura === nro[0]  
                && direccion.barrio === domicilioSplit[1].trim() && direccion.localidad === domicilioSplit[2].trim() && 
                    direccion.provincia === domicilioSplit[3].trim())
            } else {
                return (direccion.calle === calle.trim()  && direccion.altura === nro[0]  
                && direccion.localidad === domicilioSplit[1].trim() && 
                    direccion.provincia === domicilioSplit[2].trim())
            }
        })
        return direccion ? direccion.observaciones : '-';
    }

    return (
        <>
            <Subtitulo
                accordion
                accordionOpen={datosUbicacionAccordion}
                onClickAccordion={() => setDatosUbicacionAccordion(!datosUbicacionAccordion)}
                titulo="Datos de ubicación"
                txt16
                id="subtitulo-datos"
            />
            
            {
                datosUbicacionAccordion && 
                <>
                    <IonGrid className='datos-ubicacion-accordion__grid'>
                        <IonRow className='datos-ubicacion-accordion__row'>
                            <IonCol size='12'>
                                <Texto1Linea
                                    left
                                    texto="Domicilio"
                                />
                                <Texto1Linea
                                    colorBlack
                                    left
                                    texto={capitalizeString(casoBD.domicilio)}
                                    txt16
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <Texto1Linea
                                    left
                                    texto="Información adicional"
                                />
                                <Texto1Linea
                                    className='datos-ubicacion-accordion__texto'
                                    colorBlack
                                    left
                                    texto={capitalizeString(casoBD.observacionDireccion)}
                                    txt16
                                />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </>
            }
        </>
    )
}

export default DatosUbicacionAccordion